import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from './global-store-base';
import { useUser } from './user';

export const useSectionNames = defineStore('section-names', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.sectionName_GetSectionNames,
    dto: 'SectionNameDto',
    create: api.sectionName_Create,
    update: api.sectionName_Update,
    delete: api.sectionName_Delete,
    usage: api.sectionName_GetUsage,
    signalR: 'SectionNameUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.sectionName_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  return { ...globalStoreBase, replace };
});
